import React from 'react';

import { ScreenerSettingName } from './screenerSettingName';
import { useScreenerSetting } from './useScreenerSetting';

interface ScreenerSettingEnabledProps {
  settingName: ScreenerSettingName;
  facilityId: string;
  fallback?: React.ReactNode;
}

export const ScreenerSettingEnabled: React.FC<
  React.PropsWithChildren<ScreenerSettingEnabledProps>
> = ({ settingName, facilityId, fallback = null, children }) => {
  const value = useScreenerSetting(settingName, facilityId);

  if (value !== 'enabled') {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
